module.exports = __webpack_public_path__ + "static/img/qnsort2.c3d7070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnsort2.png
// module id = 362
// module chunks = 0